(() => {
  'use strict';
  const controllers = new Map();
  const DAY = 86400000;
  const KEY = 'pane-court-club-v1';
  const read = (storage, key) => { try { return JSON.parse(storage.getItem(key) || 'null'); } catch (_) { return null; } };
  const write = (storage, key, value) => { try { storage.setItem(key, JSON.stringify(value)); } catch (_) {} };
  const safeStorage = name => { try { return window[name]; } catch (_) { return { getItem: () => null, setItem: () => {} }; } };
  const local = safeStorage('localStorage');
  const session = safeStorage('sessionStorage');
  const visible = node => !!(node && !node.closest('[hidden]') && node.getClientRects().length);

  class CourtClub {
    constructor(root) {
      this.root = root;
      this.config = JSON.parse(root.querySelector('[data-pc-config]').textContent);
      this.demo = Boolean(this.config.demo || (window.Shopify && Shopify.designMode));
      this.overlay = root.querySelector('[data-pc-overlay]');
      this.panel = root.querySelector('[data-pc-panel]');
      this.launcher = root.querySelector('[data-pc-open]');
      this.form = root.querySelector('[data-pc-form]');
      this.error = root.querySelector('[data-pc-error]');
      this.status = root.querySelector('[data-pc-status]');
      this.stage = 'pick'; this.busy = false; this.opened = false; this.userActive = false;
      this.ready = this.demo || (this.config.enabled && this.config.code && this.config.stackingConfirmed && (this.config.provider !== 'klaviyo' || (this.config.companyId && this.config.listId)));
      if (!this.ready) return;
      this.abort = new AbortController();
      const listen = (el, event, fn, options = {}) => el.addEventListener(event, fn, { ...options, signal: this.abort.signal });
      this.listen = listen;
      listen(root, 'click', e => {
        const close = e.target.closest('[data-pc-close]');
        if (close) { this.close(); return; }
        const ball = e.target.closest('[data-pc-ball]');
        if (ball) this.pick(ball);
        if (e.target.closest('[data-pc-open]')) this.open(true);
        if (e.target.closest('[data-pc-copy]')) this.copy();
      });
      listen(document, 'keydown', e => this.keyboard(e));
      listen(document, 'pointerdown', () => { this.userActive = true; }, { passive: true });
      listen(window, 'scroll', () => { this.userActive = true; }, { passive: true });
      listen(this.form, 'submit', e => this.submit(e));
      listen(window, 'pageshow', () => { this.busy = false; this.submitButton(false); });
      root.querySelectorAll('[data-pc-code]').forEach(n => { n.textContent = this.config.code || 'MATCHPOINT10'; });
      const apply = root.querySelector('[data-pc-apply]');
      apply.href = this.demo ? '#preview-reward' : this.discountURL();
      if (this.demo) {
        root.querySelector('[data-pc-preview-label]').hidden = false;
        listen(apply, 'click', e => { e.preventDefault(); this.close(); });
      }
      const pending = read(session, KEY + '-pending');
      const posted = root.querySelector('[data-pc-server-success]');
      const failed = root.querySelector('[data-pc-server-errors]');
      this.rewarded = (read(local, KEY) || {}).rewardedUntil > Date.now();
      if (posted && pending && pending.until > Date.now()) {
        this.complete(); this.open(true); write(session, KEY + '-pending', null);
      } else if (failed && pending && pending.until > Date.now()) {
        this.setStage('claim'); this.open(true);
        this.error.textContent = failed.textContent.trim() || 'Please check your email address and try again.';
        this.error.hidden = false;
      } else if (this.demo) { this.open(true); }
      else {
        if (this.config.launcher && !this.config.subscriber && !this.rewarded) this.launcher.hidden = false;
        if (!this.config.subscriber && !this.rewarded && !this.excluded()) this.schedule();
      }
    }
    discountURL() {
      const locale = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
      const base = locale.startsWith('/') && !locale.startsWith('//') ? locale : '/';
      return base.replace(/\/?$/, '/') + 'discount/' + encodeURIComponent(this.config.code) + '?redirect=' + encodeURIComponent(base.replace(/\/?$/, '/') + 'collections/all');
    }
    excluded() { return /\/(cart|checkout|checkouts|account|challenge|password)(\/|$)/.test(location.pathname); }
    dismissed() { return (read(local, KEY) || {}).dismissedUntil > Date.now(); }
    obstructed() {
      if (document.hidden) return true;
      const active = document.activeElement;
      if (active && active.matches('input,textarea,select,[contenteditable=true]')) return true;
      const candidates = document.querySelectorAll('[aria-modal="true"],dialog[open],#shopify-pc__banner,.kl-private-reset-css-Xuajs1[role="dialog"]');
      return [...candidates].some(n => !this.root.contains(n) && visible(n));
    }
    schedule() {
      if (this.dismissed() || !this.ready) return;
      const start = Date.now();
      const tick = () => {
        if (!this.root.isConnected || this.opened || this.dismissed()) return;
        const range = document.documentElement.scrollHeight - innerHeight;
        const scroll = range > 0 ? scrollY / range * 100 : (this.userActive ? 100 : 0);
        const elapsed = Date.now() - start >= Number(this.config.delay || 12) * 1000;
        if (elapsed && scroll >= Number(this.config.scroll || 20) && !this.obstructed()) { this.open(false); return; }
        this.autoTimer = setTimeout(tick, 1000);
      };
      this.autoTimer = setTimeout(tick, 1000);
    }
    open(manual) {
      if (!this.ready || this.opened || (!manual && this.obstructed())) return;
      clearTimeout(this.autoTimer);
      if (this.rewarded) this.setStage('success');
      this.previousFocus = document.activeElement;
      this.scrollBefore = window.scrollY;
      this.bodyStyle = { overflow: document.body.style.overflow, paddingRight: document.body.style.paddingRight };
      const scrollbar = innerWidth - document.documentElement.clientWidth;
      document.body.style.overflow = 'hidden';
      if (scrollbar > 0) document.body.style.paddingRight = scrollbar + 'px';
      this.inertNodes = [];
      // Hide background branches at every ancestor level, while keeping the popup reachable.
      let branch = this.root;
      while (branch && branch !== document.body) {
        for (const n of branch.parentElement?.children || []) {
          if (n !== branch && !['SCRIPT','STYLE','LINK'].includes(n.tagName)) {
            this.inertNodes.push([n, n.inert]); n.inert = true;
          }
        }
        branch = branch.parentElement;
      }
      this.overlay.hidden = false; this.opened = true; this.launcher.hidden = true;
      this.focusHeading();
    }
    close() {
      if (!this.opened) return;
      this.overlay.hidden = true; this.opened = false;
      this.inertNodes?.forEach(([n, value]) => { n.inert = value; });
      Object.assign(document.body.style, this.bodyStyle);
      if (!this.demo) {
        const saved = read(local, KEY) || {};
        write(local, KEY, { ...saved, dismissedUntil: Date.now() + Number(this.config.dismissDays || 7) * DAY });
      }
      this.launcher.hidden = !this.config.launcher || this.config.subscriber || this.rewarded;
      if (this.demo) this.launcher.hidden = false;
      if (this.previousFocus?.isConnected) this.previousFocus.focus({ preventScroll: true });
    }
    keyboard(e) {
      if (!this.opened) return;
      if (e.key === 'Escape') { e.preventDefault(); this.close(); return; }
      if (e.key !== 'Tab') return;
      const nodes = [...this.overlay.querySelectorAll('a[href],button:not([disabled]),input:not([disabled]),[tabindex="0"]')].filter(n => !n.closest('[hidden]') && n.type !== 'hidden' && n.tabIndex >= 0);
      const first = nodes[0], last = nodes[nodes.length - 1];
      if (!first) { e.preventDefault(); return; }
      if (e.shiftKey && (document.activeElement === first || !nodes.includes(document.activeElement))) { e.preventDefault(); last.focus(); }
      else if (!e.shiftKey && (document.activeElement === last || !nodes.includes(document.activeElement))) { e.preventDefault(); first.focus(); }
    }
    focusHeading() { this.root.querySelector('[data-pc-screen="' + this.stage + '"] [data-pc-heading]')?.focus({ preventScroll: true }); }
    setStage(stage) {
      this.stage = stage; this.panel.dataset.stage = stage;
      this.root.querySelectorAll('[data-pc-screen]').forEach(n => { n.hidden = n.dataset.pcScreen !== stage; });
      this.overlay.setAttribute('aria-labelledby', this.root.querySelector('[data-pc-screen="' + stage + '"] [data-pc-heading]').id);
      if (this.opened) this.focusHeading();
    }
    pick(ball) {
      if (this.stage !== 'pick' || this.picking) return;
      this.picking = true; ball.dataset.picked = '';
      this.root.querySelector('[data-pc-court]').dataset.picking = '';
      this.root.querySelectorAll('[data-pc-ball]').forEach(n => { n.disabled = true; });
      this.status.textContent = 'Your reward: an extra 10% off.';
      const reduced = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      this.pickTimer = setTimeout(() => { this.setStage('claim'); this.picking = false; }, reduced ? 0 : 650);
    }
    submitButton(busy) {
      const button = this.form.querySelector('[type=submit]');
      if (button) { button.disabled = busy; button.textContent = busy ? 'Claiming your reward…' : 'Join & claim my 10% →'; }
    }
    async submit(e) {
      if (this.stage !== 'claim' || this.busy) { e.preventDefault(); return; }
      this.error.hidden = true;
      const email = this.form.querySelector('[type=email]');
      email.value = email.value.trim();
      if (!this.form.checkValidity()) { e.preventDefault(); this.form.reportValidity(); return; }
      if (this.form.querySelector('[data-pc-hp]').value) { e.preventDefault(); return; }
      this.busy = true; this.submitButton(true);
      if (this.demo) { e.preventDefault(); this.demoTimer = setTimeout(() => { this.complete(); }, 450); return; }
      if (this.config.provider === 'shopify') {
        // Native form keeps Shopify validation/challenge and server confirmation intact.
        write(session, KEY + '-pending', { until: Date.now() + 30 * 60000 });
        this.nativeTimer = setTimeout(() => { this.busy = false; this.submitButton(false); }, 15000);
        return;
      }
      e.preventDefault();
      const request = new AbortController(); this.request = request;
      const timeout = setTimeout(() => request.abort(), 15000);
      try {
        const response = await fetch('https://a.klaviyo.com/client/subscriptions?company_id=' + encodeURIComponent(this.config.companyId), {
          method: 'POST', signal: request.signal,
          headers: { 'Content-Type': 'application/vnd.api+json', 'Accept': 'application/vnd.api+json', 'revision': '2026-07-15' },
          body: JSON.stringify({ data: { type: 'subscription', attributes: { custom_source: 'PANÉ Court Club — guaranteed extra 10%', profile: { data: { type: 'profile', attributes: { email: email.value, properties: { pane_signup_source: 'court_club_game', pane_offer: 'extra_10_percent' }, subscriptions: { email: { marketing: { consent: 'SUBSCRIBED' } } } } } } }, relationships: { list: { data: { type: 'list', id: this.config.listId } } } } })
        });
        if (response.status !== 202) throw new Error(response.status === 429 ? 'rate' : 'subscription');
        this.complete();
      } catch (error) {
        this.error.textContent = error.message === 'rate' ? 'Please wait a moment, then try again. Your 10% reward is still here.' : 'That didn’t go through. Check your connection and try again—your 10% reward is still here.';
        this.error.hidden = false; this.busy = false; this.submitButton(false);
      } finally { clearTimeout(timeout); this.request = null; }
    }
    complete() {
      this.busy = false; this.rewarded = true; this.submitButton(false); this.setStage('success');
      this.status.textContent = 'Your extra 10% code is ready.';
      if (!this.demo) write(local, KEY, { rewardedUntil: Date.now() + 180 * DAY });
      if (this.config.provider === 'klaviyo' && this.config.doubleOptIn) this.root.querySelector('[data-pc-optin]').hidden = false;
    }
    async copy() {
      const code = this.config.code || 'MATCHPOINT10';
      const button = this.root.querySelector('[data-pc-copy]');
      try {
        if (!navigator.clipboard?.writeText) throw new Error('clipboard');
        await navigator.clipboard.writeText(code); button.textContent = 'Copied';
        this.status.textContent = 'Discount code copied.';
      } catch (_) {
        const range = document.createRange(); range.selectNodeContents(this.root.querySelector('[data-pc-code]'));
        const selection = window.getSelection(); selection.removeAllRanges(); selection.addRange(range);
        button.textContent = 'Select and copy the code above';
      }
    }
    destroy() { clearTimeout(this.autoTimer); clearTimeout(this.pickTimer); clearTimeout(this.demoTimer); clearTimeout(this.nativeTimer); this.request?.abort(); this.close(); this.abort?.abort(); }
  }
  function mount(scope = document) {
    scope.querySelectorAll('[data-pane-club]').forEach(root => {
      if (!controllers.has(root.id)) controllers.set(root.id, new CourtClub(root));
    });
  }
  window.PaneCourtClub = { open: () => { for (const c of controllers.values()) c.open(true); } };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => mount(), { once: true }); else mount();
  document.addEventListener('shopify:section:load', e => mount(e.target));
  document.addEventListener('shopify:section:unload', e => {
    e.target.querySelectorAll('[data-pane-club]').forEach(root => { controllers.get(root.id)?.destroy(); controllers.delete(root.id); });
  });
})();
